module.exports = __webpack_public_path__ + "img/activity_41.043ae847.png";